import {put, takeEvery, call} from 'redux-saga/effects';
import {
    FETCH_USER_REQUEST,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILURE,
    FETCH_USER,
    CLEAR_USER_ACTION,
    CLEAR_USER
} from './constants';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* getUserData() {
    try {
        yield put({
            type: FETCH_USER_REQUEST
        });
        const data = yield call(Api.fetch, {
            endpoint: 'users/me',
            method: ApiMethods.GET
        });
        yield put({
            type: FETCH_USER_SUCCESS,
            payload: data.responseData
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_FAILURE
        });
    }
}

function* getUserSaga() {
    yield takeEvery(FETCH_USER, getUserData);
}

function* clearUserData() {
    yield put({
        type: CLEAR_USER_ACTION
    });
}

function* clearUserSaga() {
    yield takeEvery(CLEAR_USER, clearUserData);
}

export {
    getUserSaga,
    clearUserSaga
};
